import React, { useState } from "react";
import { expirationDateValue, supportsExpirationDate } from "../../utils/expirationDate";
import { useReceivingPopupUi } from "./receivingPopupMessages";

export default function ExpirationDateField({ line, item, onChange, onBlur, disabled = false, pendingItem = false }) {
  const { t } = useReceivingPopupUi();
  const [editing, setEditing] = useState(false);
  const value = expirationDateValue(line?.expiration_date);
  if (!pendingItem && !supportsExpirationDate(item, line)) return <span aria-label={t("Not applicable")}>—</span>;
  const name = item?.name || line?.item_name || line?.item?.name || line?.description || "";
  // Empty native date controls can paint today's date as a browser hint. Keep
  // them as empty text fields until the user deliberately starts editing.
  return <input type={value || editing ? "date" : "text"} min="0001-01-01" max="9999-12-31" className="form-control purchasing-expiration-date"
    aria-label={`${t("Expiration date")}${name ? `: ${name}` : ""}`}
    title={t("Optional expiration date")}
    placeholder={t("Add date")}
    value={value}
    disabled={disabled || pendingItem}
    onFocus={() => setEditing(true)}
    onChange={(event) => onChange(event.target.value || null)}
    onBlur={(event) => { setEditing(false); onBlur?.(event); }} />;
}
